import { render, staticRenderFns } from "./ChildDetail.vue?vue&type=template&id=5f3fc858&scoped=true"
import script from "./ChildDetail.vue?vue&type=script&lang=ts"
export * from "./ChildDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3fc858",
  null
  
)

export default component.exports